import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "newItem", "hiddenInput", "hiddenName"];

  submit() {}

  connect() {
    this.items = Array.from(this.listTarget.querySelectorAll("li")).map(
      (li) => ({ id: li.dataset.id, name: li.textContent.trim() })
    );
  }

  search() {
    const text = this.inputTarget.value.trim();
    const query = text.toLowerCase();
    let hasResult = false;

    this.listTarget.classList.remove("hidden");

    this.items.forEach((item, index) => {
      const li = this.listTarget.children[index];
      if (item.name.toLowerCase().includes(query)) {
        li.classList.remove("hidden");
        hasResult = true;
      } else {
        li.classList.add("hidden");
      }
    });
  }

  select(event) {
    const selection = event.target.textContent.trim();

    this.inputTarget.value = selection;
    this.hiddenInputTarget.value = selection || "";

    this.close();
    this.inputTarget.dispatchEvent(new Event("autosubmit:select"));

    this.element.requestSubmit();
  }

  open() {
    this.listTarget.classList.remove("hidden");
  }

  closeWithDelay() {
    setTimeout(() => this.close(), 150);
  }

  close() {
    this.listTarget.classList.add("hidden");
  }
}
